import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "biz-gubun-picker__status"
}
const _hoisted_2 = {
  key: 1,
  class: "biz-gubun-picker__status biz-gubun-picker__status--error"
}
const _hoisted_3 = { class: "biz-gubun-picker__chips" }
const _hoisted_4 = ["disabled", "onClick"]
const _hoisted_5 = {
  key: 0,
  class: "biz-gubun-picker__summary"
}
const _hoisted_6 = {
  key: 1,
  class: "biz-gubun-picker__hint"
}

import { computed } from 'vue'
import type { BizGubunOption } from '@/api/member'
import { filterBizGubunOptions } from '@/utils/bizGubun'


export default /*@__PURE__*/_defineComponent({
  __name: 'BizGubunPicker',
  props: {
    modelValue: {},
    options: {},
    loading: { type: Boolean, default: false },
    loadError: { default: '' },
    disabled: { type: Boolean, default: false },
    showInvalid: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const visibleOptions = computed(() => filterBizGubunOptions(props.options))

const hasSelection = computed(() => props.modelValue.length > 0)

function toggle(value: string) {
  if (props.disabled) return

  const next = props.modelValue.includes(value)
    ? props.modelValue.filter((item) => item !== value)
    : [...props.modelValue, value]

  emit('update:modelValue', next)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["biz-gubun-picker", {
      'biz-gubun-picker--valid': hasSelection.value,
      'biz-gubun-picker--invalid': __props.showInvalid,
    }])
  }, [
    (__props.loading)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, "사업구분 불러오는 중..."))
      : (__props.loadError)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(__props.loadError), 1))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleOptions.value, (item) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: item.value,
                  type: "button",
                  class: _normalizeClass(["biz-gubun-picker__chip", { 'biz-gubun-picker__chip--on': __props.modelValue.includes(item.value) }]),
                  disabled: __props.disabled,
                  onClick: ($event: any) => (toggle(item.value))
                }, _toDisplayString(item.label), 11, _hoisted_4))
              }), 128))
            ]),
            (hasSelection.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(__props.modelValue.length) + "개 선택 · " + _toDisplayString(__props.modelValue.join(', ')), 1))
              : (_openBlock(), _createElementBlock("p", _hoisted_6, "해당하는 서비스를 모두 선택해 주세요."))
          ], 64))
  ], 2))
}
}

})